import './bootstrap';

console.log("app.js loaded");

const mobileMaxWidth = 767;
const mobileNavMaxWidth = 1023;
const html = document.documentElement;
const body = document.body;
const fixedHeader = document.getElementById("page_header");

const mainNav = document.getElementById("main_nav");
const navItemsWithSubnav = mainNav.querySelectorAll("li.has_children");
const mainNavHamburger = document.getElementById("main_nav_hamburger");

const recaptchaSiteKeyMeta = document.querySelector('meta[name="recaptcha-site-key"]');
const recaptchaSiteKey = recaptchaSiteKeyMeta?.getAttribute('content');

let showSubNavTimeout;
let hideSubNavTimeout;

//mobile screen size detect
window.isMobile = (window.innerWidth <= mobileMaxWidth);
window.isMobileNav = (window.innerWidth <= mobileNavMaxWidth);

window.csrfToken = () => {
    return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
}

window.setFieldError = (input, message) => {
    const container = input.closest('.input-group, .form_group, .form-group, .field, .input');
    window.clearFieldError(input);
    input.setAttribute('aria-invalid', 'true');
    if (container) container.classList.add('has_error');
    const err = document.createElement('p');
    err.className = 'field-error';
    err.textContent = message;
    (container || input.parentElement).appendChild(err);
};

window.clearFieldError = (input) => {
    input.setAttribute('aria-invalid', 'false');
    const container = input.closest('.input-group, .form_group, .form-group, .field, .input');
    const scope = container || input.parentElement;
    scope?.querySelectorAll('.field-error').forEach(el => el.remove());
    container?.classList.remove('has_error');
};

window.validateMemberNumber = async (memberId) => {
    if (!/^\d+$/.test(String(memberId)) || parseInt(memberId, 10) <= 0) {
        return { verified: false, status: 422 };
    }

    try {
        const response = await fetch('/json/toolkit/membership-verification', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-TOKEN': window.csrfToken(),
            },
            body: JSON.stringify({ member_id: String(memberId) }),
        });

        return { verified: response.ok, status: response.status };

    } catch {
        return { verified: false, status: null };
    }
}

const preventBodyScroll = () => {
    body.classList.add('noscroll');
}
const allowBodyScroll = () => {
    body.classList.remove('noscroll');
}

window.getDeviceDetails = function() {
    function getThemeMode() {
        return window.matchMedia("(prefers-color-scheme: dark)").matches ? "Dark Mode" : "Light Mode";
    }

    return {
        themeMode: getThemeMode(),
        screen: {
            width: window.screen.width,
            height: window.screen.height,
            devicePixelRatio: window.devicePixelRatio,
            orientation: screen.orientation?.type || "Unknown"
        }
    };
}

window.stripTags = (html) => {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
}

//Modals
window.showModal = function (modal_id) {
    const modal = document.querySelector("#modals_container .modal[data-modal-id=\"" + modal_id + "\"");
    if (modal) {
        modal.classList.add("visible");
        modal.dispatchEvent(new Event('show'));
        const focusField = modal.querySelector("[data-focus-on-show-modal]");
        if (focusField) {
            focusField.focus();
        }
    }
}

window.hideModal = function (modal_id = null) {
    let modals, modal_to_close;
    if (modal_id !== null) {
        modal_to_close = document.querySelectorAll("#modals_container .modal[data-modal-id=\"" + modal_id + "\"");
    } else {
        modals = document.querySelectorAll("#modals_container .modal");

        for (let modal of modals) {
            const rect = modal.getBoundingClientRect();

            // Check the center point of the modal
            const centerX = rect.left + rect.width / 2;
            const centerY = rect.top + rect.height / 2;

            const topElement = document.elementFromPoint(centerX, centerY);

            // Check if the modal is the topmost at its own center
            if (modal.contains(topElement) || modal === topElement) {
                modal_to_close = modal;
            }
        }
    }
    modal_to_close.classList.remove("visible");
    modal_to_close.dispatchEvent(new Event('hide'));

    // If URL hash is a modal hash (e.g. #modal-slug), clear it without reloading or scrolling
    try {
        if (typeof location !== 'undefined' && typeof history !== 'undefined') {
            const hash = location.hash || '';
            if (/^#modal-[A-Za-z0-9_-]+$/.test(hash)) {
                const newUrl = location.pathname + location.search;
                if (typeof history.replaceState === 'function') {
                    history.replaceState(null, '', newUrl);
                } else {
                    location.hash = '';
                }
            }
        }
    } catch (e) {
        // Silently ignore
    }
}

window.modal = function (content, title = null, rich = false) {
    const dynamic_modal = document.querySelector("#modals_container .modal[data-modal-id=\"dynamic\"]");
    if (!rich) {
        content = "<p>" + content + "</p>";
    }
    if (title == null) {
        title = "Message";
    }
    dynamic_modal.querySelector(".modal_header > h4 > span").innerHTML = title;
    dynamic_modal.querySelector(".modal_content").innerHTML = content;
    window.showModal('dynamic');
}

window.richModal = function (content, title = null) {
    window.modal(content, title, true);
}

//lazy load

window.fadeLazyLoadImage = function (image) {
    if (image.complete) {
        // If the image is already loaded from cache, add loaded class immediately
        image.classList.add("loaded");
    } else {
        image.addEventListener("load", () => {
            image.decode().then(() => {
                image.classList.add("loaded");
            }).catch(() => {
                // If something went wrong, add loaded class anyway
                image.classList.add("loaded");
            });
        });
    }
}

window.hideNav = function () {

}

window.hideSubNav = function () {
    //get all open subnav items...
    navItemsWithSubnav.forEach(navItemWithSubNav => {
        navItemWithSubNav.classList.remove("open");
    });
    fixedHeader.classList.remove("subnav_open");
}

window.loadReCaptcha = function (callback) {
    if (typeof grecaptcha !== 'undefined') {
        callback();
        return;
    }

    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}`;
    script.async = true;
    script.defer = true;
    script.onload = callback;
    document.head.appendChild(script);
}

document.addEventListener("DOMContentLoaded", () => {
    console.log("resize");
    //mobile screen size detector
    window.addEventListener('resize', () => {
        window.isMobile = (window.innerWidth <= mobileMaxWidth);
        window.isMobileNav = (window.innerWidth <= mobileNavMaxWidth);
        if (!window.isMobileNav) {
            if (fixedHeader) {
                fixedHeader.classList.remove("nav_open");
                window.hideSubNav();
            }
            if (mainNav) {
                mainNav.classList.remove("open");
            }
            if (mainNavHamburger) {
                mainNavHamburger.classList.remove("open");
            }
            allowBodyScroll();
        }
    });

    //scrolling header behaviour
    if (fixedHeader) {
        window.addEventListener('scroll', () => {
            // Get the current vertical scroll position
            const scrollTop = window.scrollY || html.scrollTop;
            const trustMessaging = document.getElementById("header_trust_messaging");
            const minimalHeader = document.getElementById("page_header").classList.contains("minimal");

            if (((window.isMobileNav || minimalHeader) && scrollTop > 0) || (!window.isMobileNav && scrollTop > 250)) {
                fixedHeader.classList.add("scrolled");
            } else {
                fixedHeader.classList.remove("scrolled");
            }
        });
        window.dispatchEvent(new Event('scroll'));
    }

    //NAV

    //hamburger

    mainNavHamburger.addEventListener('click', (event) => {
        event.preventDefault();
        mainNav.classList.toggle("open");
        mainNavHamburger.classList.toggle("open");
        if (mainNav.classList.contains("open")) {
            fixedHeader.classList.add("nav_open");
            preventBodyScroll();
        } else {
            fixedHeader.classList.remove("nav_open");
            window.hideSubNav();
            allowBodyScroll();
        }
    });

    //subnav behaviour

    navItemsWithSubnav.forEach(navItemWithSubNav => {
        navItemWithSubNav.addEventListener('mouseenter', (event) => {
            if (!window.isMobileNav) {
                clearTimeout(hideSubNavTimeout);
                showSubNavTimeout = setTimeout(() => {
                    fixedHeader.classList.add("nav_open");
                }, 300);
            }
        });
        navItemWithSubNav.addEventListener('mouseleave', (event) => {
            if (!window.isMobileNav) {
                clearTimeout(showSubNavTimeout);
                hideSubNavTimeout = setTimeout(() => {
                    fixedHeader.classList.remove("nav_open");
                }, 300);
            }
        });
        navItemWithSubNav.querySelector(":scope > a").addEventListener('click', (event) => {
            if (window.isMobileNav) {
                event.preventDefault();
                fixedHeader.classList.add("subnav_open");
                navItemWithSubNav.classList.add("open");
            }
        });
    });

    document.getElementById("nav_back_button").addEventListener('click', (event) => {
        event.preventDefault();
        window.hideSubNav();
    });

    //modal show / hide events
    document.addEventListener('click', (event) => {
        if (event.target) {
            const modalTrigger = event.target.closest('[data-show-modal]');
            if (modalTrigger) {
                event.preventDefault();
                window.showModal(modalTrigger.getAttribute('data-show-modal'));
            }
        }
    });

    document.addEventListener('mousedown', (event) => { //needs mousedown for close to stop accidental drags off modal closing it
        if (event.target) {
            //check for clicks inside closeable modal
            const modalOuters = document.querySelectorAll("aside.modal.closeable");

            modalOuters.forEach(modalOuter => {
                if (modalOuter.contains(event.target)) {
                    const modalInner = modalOuter.querySelector(".modal_inner");
                    if (!modalInner.contains(event.target) || event.target.classList.contains('modal_close_button')) {
                        window.hideModal();
                    }
                }
            });
        }
    });

    //hide on escape being pressed
    document.addEventListener("keyup", function (event) {
        if (event.key === "Escape") {
            const modals = document.querySelectorAll("aside.modal");
            modals.forEach(modal => {
                if (modal.classList.contains("visible")) {
                    window.hideModal();
                }
            });
        }
    });


    //lazy loading images fade in
    document.querySelectorAll('img[loading="lazy"]').forEach(image => {
        window.fadeLazyLoadImage(image);
    });

    // Ajax Form Submissions
    (function initAjaxForms() {
        const forms = document.querySelectorAll('form[data-action-ajax]');
        if (!forms.length) return;

        const entryAt = Date.now();

        const clearErrors = (form) => {
            form.querySelectorAll('.field-error, .form-error, .input-error').forEach(n => n.remove());
            form.querySelectorAll('.has_error, .error').forEach(el => el.classList.remove('has_error', 'error'));
            form.querySelectorAll('[aria-invalid="true"]').forEach(el => el.setAttribute('aria-invalid', 'false'));
        };

        const showErrors = (form, errors = {}) => {
            // Top-level summary for non-field errors
            const summary = document.createElement('div');
            summary.className = 'form-error';
            const generalErrors = [];

            Object.entries(errors || {}).forEach(([field, messages]) => {
                const msgs = Array.isArray(messages) ? messages : [String(messages)];
                // Try to find input by name
                const input = form.querySelector(`[name="${CSS.escape(field)}"]`);
                if (input && input.type !== 'hidden') {
                    const err = document.createElement('p');
                    err.className = 'field-error';
                    err.textContent = msgs[0];
                    // mark container if possible
                    const container = input.closest('.input-group, .form_group, .form-group, .field, .input');
                    (container || input).classList.add('has_error');
                    input.setAttribute('aria-invalid', 'true');
                    // insert error after the input
                    (container || input.parentElement || form).appendChild(err);
                } else {
                    generalErrors.push(...msgs);
                }
            });

            if (generalErrors.length) {
                const g = document.createElement('div');
                g.className = 'form-error';
                g.innerHTML = generalErrors.map(m => `<p>${m}</p>`).join('');
                form.prepend(g);
            }

            // Focus first invalid input
            const firstInvalid = form.querySelector('[aria-invalid="true"]');
            if (firstInvalid) firstInvalid.focus({preventScroll: false});
        };

        const showSuccess = (form, payload = {}) => {
            const title = payload.title || form.getAttribute('data-success-title') || 'Thank you';
            const message = payload.message || form.getAttribute('data-success-message') || 'Your submission has been received.';
            const html = payload.html;

            const wrapper = document.createElement('div');
            wrapper.className = 'form-success';
            wrapper.setAttribute('role', 'status');
            wrapper.setAttribute('aria-live', 'polite');
            wrapper.setAttribute('tabindex', '-1'); // allow programmatic focus
            wrapper.innerHTML = html || `<h3>${title}</h3>${message}`;

            // Replace the form with the success message
            form.replaceWith(wrapper);

            // Scroll the success message into view accounting for fixed header
            const scrollToTopOf = (el) => {
                if (!el) return;
                try {
                    const header = document.getElementById('page_header');
                    const headerOffset = header ? header.offsetHeight : 0;
                    const rect = el.getBoundingClientRect();
                    const absoluteTop = rect.top + window.pageYOffset - (headerOffset + 16); // 16px breathing room
                    window.scrollTo({ top: Math.max(absoluteTop, 0), behavior: 'smooth' });
                } catch (e) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
                try { el.focus({ preventScroll: true }); } catch (e) {}
            };

            // Allow layout/styles to settle
            setTimeout(() => scrollToTopOf(wrapper), 50);
        };

        const performAjax = async (form) => {
            clearErrors(form);

            try {
                const url = form.getAttribute('action') || window.location.href;
                let method = (form.getAttribute('method') || 'GET').toUpperCase();

                const formData = new FormData(form);

                // Referrer tracking metadata
                formData.append('_entry_at', entryAt);
                formData.append('_meta[screen_resolution]', `${screen.width}x${screen.height}`);
                formData.append('_meta[locale]', navigator.language);
                formData.append('_meta[timezone]', Intl.DateTimeFormat().resolvedOptions().timeZone);

                // method spoofing via _method
                const spoof = formData.get('_method');
                if (spoof) method = String(spoof).toUpperCase();

                let fetchUrl = url;
                let fetchOpts = {
                    method,
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'same-origin'
                };

                if (method === 'GET' || method === 'HEAD') {
                    const qs = new URLSearchParams(formData).toString();
                    fetchUrl = qs ? `${url}${url.includes('?') ? '&' : '?'}${qs}` : url;
                } else {
                    fetchOpts.body = formData; // includes _token
                    // CSRF header fallback
                    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
                    if (token) (fetchOpts.headers)['X-CSRF-TOKEN'] = token;
                }

                const res = await fetch(fetchUrl, fetchOpts);
                const isJson = (res.headers.get('content-type') || '').includes('application/json');
                let data = null;
                try {
                    data = isJson ? await res.json() : null;
                } catch {
                    data = null;
                }

                if (!res.ok) {
                    // Laravel may send 422 with errors
                    const errs = data && data.errors ? data.errors : {general: ['We couldn\u2019t submit your form due to a server error. Please try again, or contact us if the problem persists.']};
                    showErrors(form, errs);
                    return;
                }

                // Success path; handle conventional shapes
                if (data && (data.success || data.status === 'ok')) {

                    const url = window.location.href.toLowerCase();
                    let type = url.includes('golf') ? 'golf' : 'health';
                    type = url.includes('racquets') ? 'racquets' : type;

                    // Google Tracking
                    if (typeof window.dataLayer !== 'undefined') {
                        dataLayer.push({
                            event: 'formSubmission',
                            formType: data?.data?.analytics?.formType ?? null,
                            attributes: {
                                club: data?.data?.analytics?.club ?? null,
                                type: type,
                                contactMethod: data?.data?.analytics?.contactMethod ?? null
                            }
                        });

                        // Log data example
                        console.log('Data Layer Data:', {
                            event: 'formSubmission',
                            formType: data?.data?.analytics?.formType ?? null,
                            attributes: {
                                club: data?.data?.analytics?.club ?? null,
                                type: type,
                                contactMethod: data?.data?.analytics?.contactMethod ?? null
                            }
                        });
                    }

                    if (data.redirect) {
                        window.location.href = data.redirect;
                        return;
                    }

                    showSuccess(form, {title: data.data.title, message: data.data.message});
                } else if (data && data.errors) {
                    showErrors(form, data.errors);
                } else {
                    // Fallback: treat as success
                    showSuccess(form, {});
                }

            } catch (err) {
                console.error('[Form AJAX] Submission error:', err);
                showErrors(form, {general: ['An unexpected error occurred. Please try again.']});
            } finally {
                // Button state is restored in the submit handler's finally block
            }
        };

        // Attach listener
        forms.forEach(form => {

            form.addEventListener('invalid', () => {
                form.classList.add('submitted');
            }, true);

            const FIELD_WRAPPER = '.input-group, .form_group, .form-group, .field, .input';
            const clearFieldError = (input) => {
                if (!input) return;
                if (input.getAttribute('aria-invalid') === 'true') {
                    input.setAttribute('aria-invalid', 'false');
                }
                const container = input.closest(FIELD_WRAPPER);
                const scope = container || input.parentElement || form;
                scope.querySelectorAll('.field-error').forEach(el => {
                    if (!container || container.contains(el)) el.remove();
                });
                if (container) container.classList.remove('has_error', 'error', 'invalid');
                const anyInvalid = form.querySelector('[aria-invalid="true"], :invalid');
                if (!anyInvalid) form.classList.remove('submitted');
            };

            // Validate clear affect
            const shouldClear = (el) => {
                if (!el) return false;
                if (el.type === 'checkbox') return el.checked;
                if (el.type === 'radio') {
                    const group = form.querySelectorAll(`input[type="radio"][name="${CSS.escape(el.name)}"]`);
                    return Array.from(group).some(r => r.checked);
                }
                if (el.tagName === 'SELECT') return el.value !== '' && el.value != null;
                const val = (el.value || '').trim();
                return el.checkValidity() || (!!val && el.hasAttribute('required'));
            };

            // Clear inputs once changed.
            const handleMaybeClear = (target) => {
                const input = target && target.closest('input, textarea, select');
                if (!input || !form.contains(input)) return;
                if (shouldClear(input)) {
                    clearFieldError(input);
                }
            };

            form.addEventListener('input', (e) => handleMaybeClear(e.target), true);
            form.addEventListener('change', (e) => handleMaybeClear(e.target), true);

            // Submit handler
            form.addEventListener('submit', async (e) => {
                e.preventDefault();
                e.stopPropagation();

                // Immediately disable the submit button to prevent double clicks
                const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
                const prevText = submitBtn && (submitBtn.value || submitBtn.textContent);
                if (submitBtn) {
                    submitBtn.disabled = true;
                    submitBtn.setAttribute('aria-busy', 'true');
                    if ('value' in submitBtn && submitBtn.value) submitBtn.value = 'Please wait...';
                    else submitBtn.textContent = 'Please wait...';
                }

                // Prevent parallel submissions per form (race conditions when multiple forms exist)
                if (form.dataset.submitting === '1') {
                    // If already submitting, keep the button disabled; do not proceed
                    return;
                }
                form.dataset.submitting = '1';

                // Determine a stable, form-specific reCAPTCHA action for better attribution
                const recaptchaAction = (
                    form.getAttribute('data-recaptcha-action') ||
                    form.getAttribute('name') ||
                    form.id ||
                    'submit'
                ).toString().toLowerCase().replace(/[^a-z0-9_\-\.]/g, '-').slice(0, 100);

                if (form.hasAttribute('data-captcha')) {
                    const ensureToken = () => new Promise((resolve, reject) => {
                        if (!window.grecaptcha || !recaptchaSiteKey) return reject(new Error('reCAPTCHA not configured'));
                        grecaptcha.ready(() => {
                            // Use a per-form action to ensure correct association on the backend and avoid cross-form confusion
                            grecaptcha.execute(recaptchaSiteKey, {action: recaptchaAction})
                                .then(token => {
                                    let input = form.querySelector('input[name="g-recaptcha-response"]');
                                    if (!input) {
                                        input = document.createElement('input');
                                        input.type = 'hidden';
                                        input.name = 'g-recaptcha-response';
                                        form.appendChild(input);
                                    }
                                    input.value = token;
                                    resolve();
                                })
                                .catch(reject);
                        });
                    });
                    try {
                        await ensureToken();
                        await performAjax(form);
                    } catch (err) {
                        if (typeof loadReCaptcha === 'function') {
                            await new Promise(result => loadReCaptcha(async () => {
                                try {
                                    await ensureToken();
                                } catch {
                                    // Silently fail
                                }
                                result();
                            }));
                            await performAjax(form);
                        } else {
                            console.warn('[Form AJAX] reCAPTCHA not available; continuing without token.');
                            await performAjax(form);
                        }
                    } finally {
                        // Release submit lock and re-enable submit button
                        delete form.dataset.submitting;
                        if (submitBtn) {
                            submitBtn.disabled = false;
                            submitBtn.removeAttribute('aria-busy');
                            if (prevText) {
                                if ('value' in submitBtn && submitBtn.value) submitBtn.value = prevText;
                                else submitBtn.textContent = prevText;
                            }
                        }
                    }
                } else {
                    try {
                        await performAjax(form);
                    } finally {
                        // Release submit lock and re-enable submit button
                        delete form.dataset.submitting;
                        if (submitBtn) {
                            submitBtn.disabled = false;
                            submitBtn.removeAttribute('aria-busy');
                            if (prevText) {
                                if ('value' in submitBtn && submitBtn.value) submitBtn.value = prevText;
                                else submitBtn.textContent = prevText;
                            }
                        }
                    }
                }
            });
        });
    })();

    const miniBookTourWidgets = document.querySelectorAll('.mini_book_a_tour');

    if (miniBookTourWidgets && miniBookTourWidgets.length > 0) {
        miniBookTourWidgets.forEach(function (widget) {
            const trigger = widget.querySelector('.js-mini-book-tour-trigger');
            if (!trigger) return;

            trigger.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                const formFields = widget.querySelectorAll('input, select, textarea');
                const invalidField = Array.from(formFields).find(field => {
                    if (field.disabled || !field.required) return false;
                    if (typeof field.checkValidity === 'function') {
                        return !field.checkValidity();
                    }

                    return !String(field.value || '').trim();
                });

                if (invalidField) {
                    if (typeof invalidField.reportValidity === 'function') {
                        invalidField.reportValidity();
                    }
                    invalidField.focus?.();
                    return false;
                }

                const modalForm = document.querySelector('[data-modal-id=book_tour]');
                if (!modalForm) return false;

                const fire = (el) => {
                    el.dispatchEvent(new Event('input', { bubbles: true }));
                    el.dispatchEvent(new Event('change', { bubbles: true }));
                };

                formFields.forEach(function (field) {
                    if (!field.name || field.disabled) return;

                    const targets = modalForm.querySelectorAll(
                        `[name="${CSS.escape(field.name)}"]`
                    );
                    if (!targets.length) return;

                    const type = (field.type || '').toLowerCase();
                    const tag = (field.tagName || '').toLowerCase();

                    if (type === 'radio') {
                        if (!field.checked) return;
                        targets.forEach(t => {
                            t.checked = t.value === field.value;
                            fire(t);
                        });
                        return;
                    }

                    if (type === 'checkbox') {
                        if (targets.length === 1) {
                            targets[0].checked = field.checked;
                            fire(targets[0]);
                            return;
                        }

                        const checkedValues = new Set(
                            Array.from(widget.querySelectorAll(
                                `input[type="checkbox"][name="${CSS.escape(field.name)}"]`
                            ))
                                .filter(c => c.checked)
                                .map(c => c.value)
                        );

                        targets.forEach(t => {
                            t.checked = checkedValues.has(t.value);
                            fire(t);
                        });
                        return;
                    }

                    if (tag === 'select' && field.multiple) {
                        const values = Array.from(field.selectedOptions).map(o => o.value);
                        targets.forEach(t => {
                            Array.from(t.options).forEach(o => {
                                o.selected = values.includes(o.value);
                            });
                            fire(t);
                        });
                        return;
                    }

                    targets.forEach(t => {
                        t.value = field.value;
                        fire(t);
                    });
                });

                window.showModal('book_tour');

                return false;
            });
        });
    }

});


function handleHash() {
    const hash = window.location.hash || '';

    if (hash === '#modal-book-tour') {
        window.showModal?.('book_tour');
        return;
    }

    if (hash.startsWith('#club-')) {
        const slug = hash.slice('#club-'.length);
        const select = document.getElementById('club_id');
        if (!select) return;

        const option = select.querySelector(
            `option[data-club="${CSS.escape(slug)}"]`
        );

        if (!option) return;
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
    }

}

window.addEventListener('hashchange', handleHash);
document.addEventListener('DOMContentLoaded', handleHash);

function initTourSlots(root = document) {
    root.querySelectorAll('.js-tour-date').forEach(dateSelect => {
        if (dateSelect.dataset.tourSlotsInit === '1') return;
        dateSelect.dataset.tourSlotsInit = '1';

        const form = dateSelect.closest('form') || root;
        const timeSelect = form.querySelector('.js-tour-time');
        const slotInput  = form.querySelector('.js-tour-slot-id');

        if (!timeSelect || !slotInput) {
            console.warn('[tour-slots] missing .js-tour-time or .js-tour-slot-id');
            return;
        }

        let timeMap = {};
        try {
            timeMap = JSON.parse(dateSelect.dataset.timeMap || '{}');
        } catch (e) {
            console.error('[tour-slots] failed to parse data-time-map', e, dateSelect.dataset.timeMap);
            return;
        }

        const resetTimes = () => {
            timeSelect.innerHTML = '<option value="">Select a time</option>';
            timeSelect.disabled = true;
            slotInput.value = '';
        };

        dateSelect.addEventListener('change', () => {
            resetTimes();

            const date = dateSelect.value;
            const slots = timeMap[date];

            if (!date || !Array.isArray(slots) || !slots.length) return;

            slots.forEach(slot => {
                const opt = document.createElement('option');
                opt.value = slot.time_start;                 // <-- IMPORTANT
                opt.textContent = slot.label || slot.time_start;
                opt.dataset.slotId = slot.tour_slot_club_id; // <-- IMPORTANT
                timeSelect.appendChild(opt);
            });

            timeSelect.disabled = false;
        });

        timeSelect.addEventListener('change', () => {
            const selected = timeSelect.options[timeSelect.selectedIndex];
            slotInput.value = selected?.dataset?.slotId || '';
        });

        // if prefilled
        if (dateSelect.value) dateSelect.dispatchEvent(new Event('change'));
    });
}

// footer mobile accordion
function footerAccordionHandler() {
  if (!window.isMobile) return;

  const triggers = document.querySelectorAll('.footer-accordion-trigger');

  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const targetId = trigger.dataset.target;
      const content = document.querySelector(`[data-id="${targetId}"]`);

      trigger.classList.toggle('open');
      content?.classList.toggle('open');
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  footerAccordionHandler();
});

document.addEventListener('DOMContentLoaded', () => initTourSlots());
document.addEventListener('show', (e) => {
    // e.target will be the modal element
    initTourSlots(e.target);
}, true);

// Offer Popups: auto-show after a short delay, suppressed for
// data-dismiss-hours after the visitor closes it or clicks through.
function offerPopupDismissKey(el) {
    return `offer_popup_dismissed_${el.dataset.offerPopupId}_${el.dataset.clubId}`;
}

function offerPopupIsDismissed(el) {
    const raw = window.localStorage.getItem(offerPopupDismissKey(el));
    if (!raw) return false;

    let record;
    try {
        record = JSON.parse(raw);
    } catch {
        return false; // not a record we recognise - treat as not dismissed
    }

    // A stale record from before the popup's content last changed no longer
    // applies - the visitor hasn't seen this version, so let it show again.
    if (record.version !== el.dataset.offerPopupVersion) return false;

    const dismissedAt = parseInt(record.dismissedAt, 10);
    const dismissHours = parseFloat(el.dataset.dismissHours) || 24;

    return !isNaN(dismissedAt) && (Date.now() - dismissedAt) < dismissHours * 60 * 60 * 1000;
}

function offerPopupDismiss(el) {
    window.localStorage.setItem(offerPopupDismissKey(el), JSON.stringify({
        dismissedAt: Date.now(),
        version: el.dataset.offerPopupVersion,
    }));
}

document.addEventListener('DOMContentLoaded', () => {
    const offerPopup = document.querySelector('.offer-popup[data-offer-popup-id]');
    if (!offerPopup || offerPopupIsDismissed(offerPopup)) return;

    const modal = offerPopup.closest('aside.modal[data-modal-id]');
    if (!modal) return;

    // Only an explicit close (the X) or clicking through the CTA counts as
    // "seen" - not Escape/outside-click/any other way the modal might hide.
    const close = offerPopup.querySelector('.offer-popup_close');
    close?.addEventListener('click', () => offerPopupDismiss(offerPopup));

    const cta = offerPopup.querySelector('[data-offer-popup-cta]');
    cta?.addEventListener('click', () => offerPopupDismiss(offerPopup));

    setTimeout(() => window.showModal(modal.dataset.modalId), 1500);
});
